import type { ClassValue } from 'clsx';
import type { GalleryMediaT } from '../../../../../type/galleryMediaT';

import { ProductGalleryOpenButton, ProductGalleryStage } from '@vs-shop/commerce-ui/productGallery';
import { clsxm } from '@vs-shop/utils';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../../utils/intl';

import { GalleryMainMedia } from './GalleryMainMedia';

export type Props = {
  selectedMedia: GalleryMediaT;
  onOpen: () => void;
  alt: string;
  isActive: boolean;
  className?: ClassValue;
};

/**
 * The one photograph a wide viewport shows, with the control that opens it
 * full-screen.
 *
 * The open control is composed only over a photograph: a video slot is already
 * interactive, and covering it with an invisible button would swallow the play
 * control underneath.
 */
export function GalleryMainImageDesktop({
  selectedMedia,
  onOpen,
  isActive,
  alt,
  className,
}: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  return (
    <ProductGalleryStage className={clsxm(className)}>
      <GalleryMainMedia alt={alt} media={selectedMedia} isActive={isActive} preload />
      {selectedMedia.mediaType === 'image' && (
        <ProductGalleryOpenButton
          aria-label={intl.formatMessage({
            id: 'component.server.page.gallery.galleryMainImageDesktop.openGallery',
            defaultMessage: 'Otevřít galerii',
          })}
          onClick={onOpen}
        />
      )}
    </ProductGalleryStage>
  );
}
